import { CREATEJS_UTILITIES_LOGGER } from "../../../../../index";
import { getLogger } from "@goodgamestudios/logger";
import { PixelSnapping } from "./PixelSnapping";
import BitmapData = createjs.BitmapData;

const logger = getLogger(CREATEJS_UTILITIES_LOGGER + ".Bitmap");


Object.defineProperty(createjs.Bitmap.prototype, "pixelSnapping", {
    value: PixelSnapping.AUTO,
    enumerable: true,
    configurable: true,
    writable: true
});

Object.defineProperty(createjs.Bitmap.prototype, "smoothing", {
    value: false,
    enumerable: true,
    configurable: true,
    writable: true
});

type BitmapWithCacheData = createjs.Bitmap & {
    $bitmapData: createjs.BitmapData | undefined;
};

Object.defineProperty(createjs.Bitmap.prototype, "bitmapData", {
    get: function (this: BitmapWithCacheData): createjs.BitmapData {
        if (!this.$bitmapData) {
            if (!this.cacheCanvas) { this.cache(this.x, this.y, this.image.width, this.image.height); }
            this.$bitmapData = createjs.BitmapData.getBitmapData(this);
        }
        return this.$bitmapData;
    },
    set: function (this: BitmapWithCacheData, value: createjs.BitmapData) {
        this.$bitmapData = value;
        this.image = value.canvas;
        this.setBounds(0, 0, this.$bitmapData.width, this.$bitmapData.height);
    },
    enumerable: true,
    configurable: true
});

const oldPrototype = createjs.Bitmap.prototype;
const originalConstructor = createjs.Bitmap.prototype.constructor;
const oldStatic_suppressCrossDomainErrors = createjs.Bitmap.suppressCrossDomainErrors;
(<any>createjs).Bitmap = function (imageOrUrl?: HTMLImageElement | HTMLCanvasElement | HTMLVideoElement | Object | string, pixelSnapping: string = PixelSnapping.AUTO, smoothing: boolean = false): any {
    //logger.debug("constructor: smoothing and pixelSnapping aren'actually used by current implementation");
    // this.bitmapData = imageOrUrl;
    this.smoothing = smoothing;
    this.pixelSnapping = pixelSnapping;
    if (imageOrUrl && (imageOrUrl as any).canvas) {
        originalConstructor.call(this, (imageOrUrl as any).canvas, pixelSnapping, smoothing);
    } else {
        originalConstructor.call(this, imageOrUrl, pixelSnapping, smoothing);
    }
};
createjs.Bitmap.prototype = oldPrototype;
createjs.Bitmap.suppressCrossDomainErrors = oldStatic_suppressCrossDomainErrors;

/**
 * Draws the display object into the specified context ignoring its visible, alpha, shadow, and transform.
 * Returns true if the draw was handled (useful for overriding functionality).
 *
 * NOTE: This method is mainly for internal use, though it may be useful for advanced uses.
 * @method draw
 * @param {CanvasRenderingContext2D} ctx The canvas 2D context object to draw into.
 * @param {Boolean} [ignoreCache=false] Indicates whether the draw operation should ignore any current cache.
 * For example, used for drawing the cache (to prevent it from simply drawing an existing cache back
 * into itself).
 * @return {Boolean}
 **/
createjs.Bitmap.prototype.draw = function (ctx, ignoreCache) {
    if ((this as any).DisplayObject_draw(ctx, ignoreCache) || !this.image) { return true; }
    let img = this.image, rect = this.sourceRect;
    if (img instanceof HTMLCanvasElement && (img.width === 0 || img.height === 0)) {
        let bugsnagClient = (window as any).bugsnagClient;
        if (bugsnagClient) {
            logger.error("try to draw bitmap whose image is size 0 canvas.");
            bugsnagClient.notify(new Error("Bitmap image is size 0 canvas, ignore drawing..."), { severity: "warning" });
        }
        return true;
    }
    if (rect) {
        // some browsers choke on out of bound values, so we'll fix them:
        let x1 = rect.x, y1 = rect.y, x2 = x1 + rect.width, y2 = y1 + rect.height, x = 0, y = 0, w = img.width, h = img.height;
        if (x1 < 0) { x -= x1; x1 = 0; }
        if (x2 > w) { x2 = w; }
        if (y1 < 0) { y -= y1; y1 = 0; }
        if (y2 > h) { y2 = h; }
        ctx.drawImage(img, x1, y1, x2 - x1, y2 - y1, x, y, x2 - x1, y2 - y1);
    } else {
        ctx.drawImage(img, 0, 0);
    }
    return true;
};